import React, { useState, useEffect, useRef } from "react";

// import * as service from "../services";
import Barcode from "react-barcode";
import { QRCodeSVG } from "qrcode.react";
import { getNow, getAddress,getlatestNoW } from "./Util";

/* eslint-disable import/no-webpack-loader-syntax */
import matlIconCss from "../assets/styles/material-icons.css?inline";
import styleCss from "../assets/styles/style.css?inline";
import mainCss from "../assets/styles/main.css?inline";
import qmsCss from '../assets/styles/qms.css?inline';
import printCss from "../assets/styles/print.css?inline";
import testReportCss from "../assets/styles/testReport.css?inline";
const stripHtml = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
};
const ReportHeader = ({ reduxData, data }) => {
  // const [data, setData] = useState({
  //   loaded: false,
  //   logo: undefined,
  //   hq: undefined,
  // });

  // useEffect(() => {
  //   let hq = {};
  //   let p1 = new Promise((resolve, reject) => {
  //     service.executeQuery(
  //       {
  //         path: "utils/get_headquarter_logo",
  //         query_params: {},
  //       },
  //       (res) => {
  //         if (res.data && res.data.length > 0) hq = res.data[0];
  //         setData((prev) => ({ ...prev, hq: res.data[0] }));
  //         resolve("");
  //       }
  //     );
  //   });

  //   Promise.all([p1])
  //     .then((values) => {
  //       if (hq) {
  //         service.getImageData(hq.id, (res) => {
  //           if (res.status === "ERROR") console.log("Logo not found");
  //           else setData((prev) => ({ ...prev, logo: res }));
  //         });
  //       }
  //       setData((prev) => ({ ...prev, loaded: true }));
  //     })
  //     .catch((error) => {
  //       console.log(error.message);
  //     });
  // }, []);

  return (
    data.loaded && (
      <>
        <table
          cellPadding="0"
          cellSpacing="0"
          border="0"
          style={{ width: "100%" }}
        >
          <tbody>
            <tr>
              <td valign="middle" align="left" style={{ border: "none" }}>
                {data.logo && (
                  <div style={{ width: data.hq.width, height: data.hq.height }}>
                    <img
                      src={data.logo}
                      alt="LabIconics"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                )}
              </td>
              <td valign="middle" align="right" style={{ border: "none" }}>
                {getAddress(reduxData?.current_auth, true)}
              </td>
            </tr>
          </tbody>
        </table>
      </>
    )
  );
};

export const Remarks = ({ remarks }) => {
  if (remarks !== undefined) {
    return (
      remarks && (
        <div style={{ marginBottom: "10px" }}>
          <b>Remarks:</b> {remarks.description}
        </div>
      )
    );
  }
};

export const ConclusionTest = ({ previewPageProps }) => {
  console.log('previewPageProps: ', previewPageProps);
  let {
    specification_type,
    standards_type,
    tests,
    stage_test_selection,
    outsourced_tests,
    // investigation_tests,
    template_data_fields_values,
    object_id,
    auto_trigger_investigation_workflow_required,
    investigation_workflow_required,
  } = previewPageProps;
  let all_pass = true;
  let is_released_data = true;
  let all_tests_passed;
  if (!stage_test_selection) {
    const compliesText = standards_type === "With Limit" ? "standard" : "specification";
    if (object_id === "LIMS_SAMPLE_MANAGEMENT_DERIVED_COA") {
      all_tests_passed = false;
    }
    if (object_id === "LIMS_SAMPLE_MANAGEMENT_DERIVED_COA") {
      let _tests = previewPageProps.tests ? previewPageProps.tests : []; //this is for filter the outsource
      _tests &&
        _tests.map((item) => {
          if (
            item.final_result !== "Pass" &&
            ((item.test_res1 !== "Pass" && item.test_res1 !== null) ||
              (item.test_res !== "Pass" && item.test_res !== null))
          )
            all_pass = false;
          if (
            item.final_result !== "Pass" &&
            item.test_res1 === null &&
            item.test_res === null
          )
            all_pass = false;
          if (
            item.final_result !== "Pass" &&
            item.investigation_workflow_required === false &&
            all_pass === false
          ) {
            is_released_data = false;
          }
          if (!item.is_released) is_released_data = false;
          if (!item.workflow_task_id) is_released_data = false;
          if (item.all_tests_pass === true) all_tests_passed = true;
          if (item.final_result !== 'Pass') {
            all_tests_passed = false;
          }
          return item;
        });
    } else {
      let _tests = previewPageProps.tests
        ? previewPageProps.tests.filter(
            (item) =>
              item.is_out_sourced === false && item.test_status === "Submitted"
          )
        : []; //this is for filter the outsource
      _tests &&
        _tests.map((item) => {
          if (
            item.final_result !== "Pass" &&
            ((item.test_res1 !== "Pass" && item.test_res1 !== null) ||
              (item.test_res !== "Pass" && item.test_res !== null))
          )
            all_pass = false;
          if (
            item.final_result !== "Pass" &&
            item.test_res1 === null &&
            item.test_res === null
          )
            all_pass = false;
          if (
            item.final_result !== "Pass" &&
            investigation_workflow_required === false &&
            all_pass === false
          ) {
            is_released_data = false;
          }
          if (
            item.final_result !== "Pass" &&
            investigation_workflow_required === true &&
            auto_trigger_investigation_workflow_required === false &&
            all_pass === false
          ) {
            is_released_data = false;
          }
          if (!item.is_released) is_released_data = false;
          if (!item.workflow_task_id) is_released_data = false;
          return item;
        });
      let os_tests = outsourced_tests ? outsourced_tests.tests || [] : [];
      os_tests &&
        os_tests.map((item) => {
          if (
            item.test_status !== "Pass" &&
            ((item.test_res1 !== "Pass" && item.test_res1 !== null) ||
              (item.test_res !== "Pass" && item.test_res !== null))
          )
            all_pass = false;
          if (
            item.test_status !== "Pass" &&
            item.test_res1 === null &&
            item.test_res === null
          )
            all_pass = false;
          if (
            item.test_status !== "Pass" &&
            investigation_workflow_required === false &&
            all_pass === false
          ) {
            is_released_data = false;
          }
          if (
            item.test_status !== "Pass" &&
            investigation_workflow_required === true &&
            auto_trigger_investigation_workflow_required === false &&
            all_pass === false
          ) {
            is_released_data = false;
          }
          if (!item.is_released) is_released_data = false;
          if (!item.workflow_task_id) is_released_data = false;
          return item;
        });
    }
    if (template_data_fields_values.is_released === true) {
      return (
        (specification_type === "With Limit" || standards_type === "With Limit") && (
          <div style={{ marginBottom: "10px" }}>
            <b>Conclusion:</b>{" "}
            {all_pass || all_tests_passed
              ? `The above results COMPLIES with the ${compliesText}.`
              : (is_released_data && all_pass)
              ? `The above results COMPLIES with the ${compliesText}.`
              : `The above results DOES NOT COMPLIES with the ${compliesText}.`}
          </div>
        )
      );
    } else {
      return (
        (specification_type === "With Limit" || standards_type === "With Limit") && (
          <div style={{ marginBottom: "10px" }}>
            <b>Conclusion:</b>{" "}
            {
              `The above results COMPLIES / DOES NOT COMPLIES with the ${compliesText}.`
            }
          </div>
        )
      );
    }
  } else {
    const isFail = (res) => res === "Fail";

    const testIds = tests.map((t) => t.test_id);

    const hasPassingStageAncestor = (testId) => {
      const stageTests = tests.filter((t) => t.test_id === testId);
      if (!stageTests || stageTests.length === 0) return false;

      if (stageTests.length > 1) {
        const allPass = stageTests.every((st) => {
          const failed = st.is_out_sourced
            ? isFail(
                st.test_status === "Fail" &&
                  st.test_res === null &&
                  st.test_res1 === null
                  ? st.test_status
                  : st.test_status === "Fail" &&
                    st.test_res === "Fail" &&
                    st.test_res1 === null
                  ? st.test_res
                  : st.test_res1
              )
            : isFail(
                st.final_result === "Fail" &&
                  st.test_res === null &&
                  st.test_res1 === null
                  ? st.final_result
                  : st.final_result === "Fail" &&
                    st.test_res === "Fail" &&
                    st.test_res1 === null
                  ? st.test_res
                  : st.test_res1
              );
          return !failed;
        });
        return allPass;
      } else {
        const st = stageTests[0];
        const failed = st.is_out_sourced
          ? isFail(
              st.test_status === "Fail" &&
                st.test_res === null &&
                st.test_res1 === null
                ? st.test_status
                : st.test_status === "Fail" &&
                  st.test_res === "Fail" &&
                  st.test_res1 === null
                ? st.test_res
                : st.test_res1
            )
          : isFail(
              st.final_result === "Fail" &&
                st.test_res === null &&
                st.test_res1 === null
                ? st.final_result
                : st.final_result === "Fail" &&
                  st.test_res === "Fail" &&
                  st.test_res1 === null
                ? st.test_res
                : st.test_res1
            );
        if (!failed) return true;
        if (st.stage_test_id) {
          return hasPassingStageAncestor(st.stage_test_id);
        }
        return false;
      }
    };

    const stageTestIds = tests
      .filter(
        (st) => st.stage_test_id !== null && st.stage_test_id !== undefined
      )
      .map((st) => st.stage_test_id);
    const finalTests = tests.filter((st) => !stageTestIds.includes(st.test_id));
    finalTests.forEach((fntest) => {
      const failed = fntest.is_out_sourced
        ? isFail(
            fntest.test_status === "Fail" &&
              fntest.test_res === null &&
              fntest.test_res1 === null
              ? fntest.test_status
              : fntest.test_status === "Fail" &&
                fntest.test_res === "Fail" &&
                fntest.test_res1 === null
              ? fntest.test_res
              : fntest.test_res1
          )
        : isFail(
            fntest.final_result === "Fail" &&
              fntest.test_res === null &&
              fntest.test_res1 === null
              ? fntest.final_result
              : fntest.final_result === "Fail" &&
                fntest.test_res === "Fail" &&
                fntest.test_res1 === null
              ? fntest.test_res
              : fntest.test_res1
          );

      if (!failed) {
        fntest.is_pass = true;
      } else {
        if (fntest.stage_test_id) {
          const stageExists = testIds.includes(fntest.stage_test_id);
          if (stageExists) {
            fntest.is_pass = hasPassingStageAncestor(fntest.stage_test_id);
          } else {
            fntest.is_pass = !failed;
          }
        } else {
          fntest.is_pass = false;
        }
      }
    });
    const all_pass = !finalTests.some((ftest) => ftest.is_pass === false);
    if (template_data_fields_values.is_released === true) {
      return (
        specification_type === "With Limit" && (
          <div style={{ marginBottom: "10px" }}>
            <b>Conclusion:</b>{" "}
            {all_pass
              ? "The above results COMPLIES with the specification."
              : "The above results DOES NOT COMPLIES with the specification."}
          </div>
        )
      );
    } else {
      return (
        specification_type === "With Limit" && (
          <div style={{ marginBottom: "10px" }}>
            <b>Conclusion:</b> The above results COMPLIES / DOES NOT COMPLIES
            with the specification.
          </div>
        )
      );
    }
  }
};

export const RenderConclusionRemark = ({ previewPageProps, fitem }) => {
  console.log('fitem: ', fitem);
  console.log('previewPageProps: ', previewPageProps);
  let { tests, outsourced_tests } = previewPageProps;
  let all_pass = true;
  let is_released_data = true;
  const _tests = tests ? tests.filter(t => !t.is_out_sourced && t.test_status === "Submitted") : [];

  _tests.forEach(item => {
    if (item.test_inv1) {
      if (item.test_res === 'Fail' || item.test_res1 === 'Fail') {
        all_pass = false;
      }
    } else {
      if (item.final_result !== 'Pass' && (item.test_res1 !== 'Pass' || item.test_res1 === null)) {
        all_pass = false;
      }
    }
    if (!item.is_released || !item.workflow_task_id) {
      is_released_data = false;
    }
  });

  // Outsourced tests
  const os_tests = outsourced_tests?.tests || [];
  let selectedTests = [];
  if (previewPageProps?.action_menu_id === "LIMS_TESTING_MANAGEMENT_TDERIVED_COA" || previewPageProps?.action_menu_id === "LIMS_TESTING_MANAGEMENT_TCOMPILED_COA") {
    tests.forEach(test => {
      if (test.subttest_required === false) {
        const matched = os_tests.filter(os => os.test_id === test.test_id);
        selectedTests.push(...matched);
      }
      else if (test.subttest_required === true) {
        if (test.datasheet_for_subtest === true) {
          const matched = os_tests.filter(os => os.test_id === test.test_id && os.sub_test_id === test.sub_test_id);
          selectedTests.push(...matched);
        }
        else {
          const matched = os_tests.filter(os => os.test_id === test.test_id);
          selectedTests.push(...matched);
        }
      }
    });
  }
  console.log('selectedTests', selectedTests);

  const testsToValidate = ["LIMS_TESTING_MANAGEMENT_TDERIVED_COA", "LIMS_TESTING_MANAGEMENT_TCOMPILED_COA"].includes(previewPageProps?.action_menu_id) ? selectedTests : os_tests;
  testsToValidate.forEach(item => {
    if (item.test_inv1) {
      if (item.test_res === 'Fail' || item.test_res1 === 'Fail') {
        all_pass = false;
      }
    } else {
      if (item.test_status !== 'Pass' && (item.test_res1 !== 'Pass' || item.test_res1 === null)) {
        all_pass = false;
      }
    }
  });

  os_tests.forEach(item => {
    if (!item.is_released || !item.workflow_task_id) {
      is_released_data = false;
    }
  });
  let conclusionText = '';
  if (previewPageProps.standards_type === 'With Limit' || previewPageProps?.standards_type === 'With Limit') {
    if (fitem.props.standard_type === "With Limits") {
      conclusionText = all_pass ? fitem.props.pass_criteria : fitem.props.fail_criteria;
    }
  }

  if (previewPageProps.standards_type === 'Without Limit' || previewPageProps?.standards_type === 'Without Limit') {
    if (fitem.props.standard_type === "Without Limits") {
      conclusionText = fitem.props.content || '';
    }
  }
  if (!conclusionText) return null;

  // CASE 1: show_label = true
  if (fitem.show_label) {
    return (
      <div style={{ display: fitem.layout.value === "Vertical" ? 'block' : 'flex' }}>
        {/* Label */}
        <div style={{ fontWeight: 600, wordBreak: 'break-word', width: fitem.layout.value === "Vertical" ? '100%' : (fitem.label_width ? `${fitem.label_width}%` : '50%') }}>
          {fitem.field_label}
        </div>
        {/* Value */}
        <div style={{ display: 'flex', flexDirection: fitem.layout.value === "Vertical" ? 'column' : 'row', justifyContent: fitem.alignment.value.toLowerCase(), width: fitem.layout.value === "Vertical" ? '100%' : (fitem.value_width ? `${fitem.value_width}%` : '50%'), wordWrap: 'break-word' }}>
          <div style={{ textAlign: fitem.alignment.value.toLowerCase() }} dangerouslySetInnerHTML={{ __html: conclusionText.replace(/\r?\n/g, '<br />') }} />
        </div>
      </div>
    );
  }

  // CASE 2: show_label = false
  return (
    <div className="columns m-0">
      <div className="column p-0" style={{ display: 'flex', flexDirection: fitem.layout.value === "Vertical" ? 'column' : 'row', justifyContent: fitem.alignment.value.toLowerCase() }}>
        <div style={{ textAlign: fitem.alignment.value.toLowerCase(), width: fitem.value_width ? `${fitem.value_width}%` : '100%' }} dangerouslySetInnerHTML={{ __html: conclusionText.replace(/\r?\n/g, '<br />') }} />
      </div>
    </div>
  );
};

export const RenderFields = ({fields,column_widths,section_seq,col,previewPageProps,}) => {
  let {
    template_data_fields_values,
    _coaRecipe,
    specification_type,
    inv_reviewer,
    inv_approval,
    investigation_tests,
    investigation_coa,
  } = previewPageProps;
  console.log('previewPageProps: ', previewPageProps,_coaRecipe);
  const isConclusionRemarks = previewPageProps?.recipe?.is_conclusion_remarks;
  const hasConclusionRemark = Array.isArray(fields) && fields.some(field => field?.field_type?.value === "Conclusion/Remarks");
  const footerKeys = [
    "checked_by",
    "reviewed_by",
    "approved_by",
    "authorized_by",
    "checked_by_with_designation",
    "reviewed_by_with_designation",
    "approved_by_with_designation",
    "authorized_by_with_designation",
    "first_test_submitted_by_with_designation",
    "first_test_submitted_by",
    "last_test_submitted_by_with_designation",
    "last_test_submitted_by"
  ];
  if (
    inv_reviewer &&
    template_data_fields_values.reviewed_by === "" &&
    investigation_tests.length >= 1
  ) {
    template_data_fields_values.reviewed_by = inv_reviewer.reviewer_info;
  }
  if (
    inv_approval &&
    template_data_fields_values.approved_by === "" &&
    investigation_tests.length >= 1
  ) {
    template_data_fields_values.approved_by = inv_approval.approval_info;
  }
  !!template_data_fields_values &&
    Object.keys(template_data_fields_values).forEach((key, index) => {
      if (
        template_data_fields_values[key] &&
        typeof template_data_fields_values[key] === "object"
      ) {
        template_data_fields_values[key] =
          template_data_fields_values[key].value ||
          template_data_fields_values[key].flat().join(",");
      }
    });
  return (
    <>
      {fields &&
        fields.length > 0 &&
        fields
          .filter(
            (fitem) =>
              fitem.section_seq === section_seq &&
              fitem.col === col &&
              fitem.status_id === "ACTIVE"
          )
          .map((fitem, findex) => {
            let _props = fitem.props;
            fitem = { ...fitem, ..._props };
            const fieldName = fitem.object_field?.field_name;
            const values =
              investigation_coa &&
              investigation_coa.find(
                (item) => item.key === fieldName && item.value !== undefined
              )?.value;
            const isFooterKey = footerKeys.includes(fieldName);
            const uniqueGroupingNames = new Set();
            const totalCols = Array.isArray(column_widths) ? column_widths.length : 1;
            return (
              <React.Fragment
                key={section_seq + "_" + fitem.seq + "_" + findex}
              >
                {fitem.field_type.label === "Data Field" && (
                  <div
                    className="columns m-0"
                    style={{
                      maxWidth: "100%",
                      flexDirection:
                        fitem.layout.value === "Vertical" ? "column" : "row",
                        padding:'5px'
                    }}
                  >
                    <div
                      className="column p-0 mb-0 is-flex-grow-1"
                      style={{
                        maxWidth: fitem.label_width
                          ? `${fitem.label_width}%`
                          : "auto",
                      }}
                    >
                      <span style={{ fontWeight: "600", fontSize: totalCols === 6 ? '12px' : 'inherit' }}>
                        {fitem.show_label
                          ? fitem.field_label
                          : fitem.object_field.label}
                      </span>
                    </div>
                    <div
                      className="column p-0 mb-0 is-flex-grow-1"
                      style={{
                        maxWidth: fitem.value_width
                          ? `${fitem.value_width}%`
                          : "auto",
                        textAlign: fitem.alignment.value.toLowerCase(),
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                        }}
                      >
                        {fitem.object_field?.field_name === "customer_address" ? (
                          <>
                          <div style={{ display: "block" }}>
                            <strong>{template_data_fields_values["customer_name"] || "--"}</strong>
                            <br />
                            {template_data_fields_values["customer_address"] || "--"}
                          </div>
                          </>
                            
                        ) : fitem.object_field &&
                        fitem.object_field.field_name &&
                        template_data_fields_values &&
                        (fitem.object_field.field_name === "released_at" ||
                          fitem.object_field.field_name === "released_with_time" ? (

                            template_data_fields_values.is_released &&
                            template_data_fields_values[
                              fitem.object_field.field_name
                            ] ? (
                              template_data_fields_values[
                                fitem.object_field.field_name
                              ]
                            ) : (
                              "-"
                            )
                          ) : (
                            <>
                              {previewPageProps.digital_signature === true &&
                                isFooterKey &&
                                template_data_fields_values[
                                  `${fieldName}_signature`
                                ] && (
                                  <div
                                    style={{
                                      marginBottom: "5px",
                                      position: "relative",
                                      display: "inline-block",
                                      alignSelf:
                                        fitem.alignment.value.toLowerCase(),
                                    }}
                                  >
                                    <div className="tooltip-container">
                                      {template_data_fields_values[
                                        `${fieldName}_signature`
                                      ].includes("application/pdf") ? (
                                        <iframe
                                          src={
                                            template_data_fields_values[
                                              `${fieldName}_signature`
                                            ]
                                          }
                                          title={`${fieldName} PDF Signature`}
                                          width="150px"
                                          height="50px"
                                          // style={{
                                          //   border: "1px solid #ccc",
                                          // }}
                                        />
                                      ) : (
                                        <img
                                          src={
                                            template_data_fields_values[
                                              `${fieldName}_signature`
                                            ]
                                          }
                                          alt={`${fieldName} Signature`}
                                          style={{
                                            height: "50px",
                                            width: "150px",
                                            display: "block",
                                          }}
                                        />
                                      )}
                                      <span
                                        className="tooltip-text"
                                        style={{ fontSize: "14px" }}
                                      >
                                        <i
                                          className="mdi mdi-check-decagram"
                                          style={{
                                            color: "green",
                                            marginRight: "2px",
                                          }}
                                        ></i>
                                        Verified
                                      </span>
                                    </div>
                                  </div>
                                )}

                              {/* <span style={{ wordBreak: "break-word" }}>
                                {template_data_fields_values[fieldName] ||
                                  (values && values.length > 0
                                    ? values
                                    : "--") ||
                                  "--"}
                              </span> */}
                                {(() => {
                                  const val = template_data_fields_values[fieldName] || "--";
                                  const dateTimeRegex = /(\d{2}-[A-Za-z]{3}-\d{4})\s+(\d{1,2}:\d{2}\s*(?:AM|PM))/i;
                                  const match = dateTimeRegex.exec(val);
                                  if (match) {
                                    const beforeDate = val.slice(0, match.index);
                                    const datePart = match[1];
                                    const timePart = match[2].trim();
                                    const afterTime = val.slice(match.index + match[0].length);
                                    return (
                                      <span style={{ display: 'block', width: '100%', fontSize: totalCols <= 4 ? 'inherit' : totalCols === 6 ? '10px' : '12px', lineHeight: '1.4', wordBreak: 'break-word', overflowWrap: 'break-word', }}>
                                        {beforeDate && <span>{beforeDate}</span>}
                                        {totalCols <= 2 ? (
                                          <span style={{ display: 'block', whiteSpace: 'nowrap' }}>
                                            {datePart} {timePart}
                                          </span>
                                        ) : (
                                          <>
                                            <span style={{ display: 'block', whiteSpace: 'nowrap' }}>{datePart}</span>
                                            <span style={{ display: 'block', whiteSpace: 'nowrap' }}>{timePart}</span>
                                          </>
                                        )}
                                        {afterTime && <span>{afterTime}</span>}
                                      </span>
                                    );
                                  }
                                  return (
                                    // <span style={{ display: 'block', width: '100%', lineHeight: '1.4', wordBreak: 'break-word', overflowWrap: 'break-word', }}>{val}</span>
                                    <span style={{ display: 'block', width: '100%', lineHeight: '1.4', wordBreak: 'break-word', overflowWrap: 'break-word', }}
                                      dangerouslySetInnerHTML={{
                                        __html: (val || "").replace(
                                          /color\s*:\s*[^;"]+;?\s*/gi,
                                          ""
                                        ),
                                      }}
                                    />
                                  );
                                })()}
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* FOR SHOW LABEL */}
                {fitem.field_type.label === "Title" && fitem.show_label && (
                  <div
                    className=""
                    style={{
                      display:
                        fitem.layout.value === "Vertical" ? "block" : "flex",
                    }}
                  >
                    <div
                      className=""
                      style={{
                        fontWeight: "600",
                        wordBreak: "break-word",
                        width:
                          fitem.layout.value === "Vertical"
                            ? "100%"
                            : fitem.label_width
                            ? `${fitem.label_width}%`
                            : "50%",
                      }}
                    >
                      {fitem.field_label}
                    </div>

                    <div
                      className="p-0"
                      style={{
                        display: "flex",
                        flexDirection:
                          fitem.layout.value === "Vertical" ? "column" : "row",
                        justifyContent: fitem.alignment.value.toLowerCase(),
                        width:
                          fitem.layout.value === "Vertical"
                            ? "100%"
                            : fitem.value_width
                            ? `${fitem.value_width}%`
                            : "50%",
                        wordWrap: "break-word",
                      }}
                    >
                      <div
                        style={{
                          textAlign: fitem.alignment.value.toLowerCase(),
                          fontSize: "18px",
                          fontWeight: previewPageProps.module_name === 'TESTING_MANAGEMENT' && (!previewPageProps.font_size_version || previewPageProps.font_size_version === null) ? '600' : 'normal',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: fitem.title.replace(/\r?\n/g, "<br />"),
                        }}
                      ></div>
                    </div>
                  </div>
                )}

                {fitem.field_type.label === "Title" && !fitem.show_label && (
                  <div className="columns m-0">
                    <div
                      className="column p-0"
                      style={{
                        display: "flex",
                        flexDirection:
                          fitem.layout.value === "Vertical" ? "column" : "row",
                        justifyContent: fitem.alignment.value.toLowerCase(),
                      }}
                    >
                      {fitem.show_label && (
                        <div style={{ fontWeight: "600" }}>
                          {fitem.field_label}
                        </div>
                      )}
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: previewPageProps.module_name === 'TESTING_MANAGEMENT' && (!previewPageProps.font_size_version || previewPageProps.font_size_version === null) ? '600' : 'normal',
                          textAlign: fitem.alignment.value.toLowerCase(),
                          width: fitem.value_width
                            ? `${fitem.value_width}%`
                            : "100%",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: fitem.title.replace(/\r?\n/g, "<br />"),
                        }}
                      ></div>
                    </div>
                  </div>
                )}

                {/* FOR SHOW LABEL */}
                {fitem.field_type.label === "Text" && fitem.show_label && (
                  <div
                    className=""
                    style={{
                      display:
                        fitem.layout.value === "Vertical" ? "block" : "flex",
                    }}
                  >
                    <div style={{ fontWeight: "600",wordBreak: 'break-word', width: fitem.layout.value === "Vertical" ? '100%':(fitem.label_width ? `${fitem.label_width}%` : '50%') }}>{fitem.field_label}</div>

                    <div
                      className="column p-0"
                      style={{
                        display: "flex",
                        flexDirection:
                          fitem.layout.value === "Vertical" ? "column" : "row",
                        justifyContent: fitem.alignment.value.toLowerCase(),
                      }}
                    >
                      <div
                        style={{
                          paddingLeft: "5px",
                          textAlign: fitem.alignment.value.toLowerCase(),
                        }}
                        dangerouslySetInnerHTML={{
                          __html: fitem.text.replace(/\r?\n/g, "<br />"),
                        }}
                      ></div>
                    </div>
                  </div>
                )}
                {fitem.field_type.label === "Text" && !fitem.show_label && (
                  <div className="columns m-0">
                    <div
                      className="column p-0"
                      style={{
                        display: "flex",
                        flexDirection:
                          fitem.layout.value === "Vertical" ? "column" : "row",
                        justifyContent: fitem.alignment.value.toLowerCase(),
                      }}
                    >
                      {fitem.show_label && (
                        <div style={{ fontWeight: "600" }}>
                          {fitem.field_label}
                        </div>
                      )}
                      <div
                        style={{
                          textAlign: fitem.alignment.value.toLowerCase(),
                        }}
                        dangerouslySetInnerHTML={{
                          __html: fitem.text.replace(/\r?\n/g, "<br />"),
                        }}
                      ></div>
                    </div>
                  </div>
                )}

                {fitem.field_type.label === "Image" && (
                  <div className="columns m-0">
                    <div className="column p-0 mb-2">
                      <div
                        style={{
                          textAlign: fitem.alignment.value.toLowerCase(),
                        }}
                      >
                        <img
                          src={
                            previewPageProps.images[
                              section_seq + "_" + fitem.col + "_" + fitem.seq
                            ]
                          }
                          alt=""
                          style={{
                            width: `${fitem.width}px`,
                            height: `${fitem.height}px`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {fitem.field_type.label === "Image Field" && (
                  <div className="columns m-0">
                    <div className="column p-0 mb-2">
                      <div
                        style={{
                          textAlign: fitem.alignment.value.toLowerCase(),
                        }}
                      >
                        {!!previewPageProps?.addImage ||
                        !!previewPageProps.addImage ? (
                          <img
                            src={
                              previewPageProps.addImage ||
                              previewPageProps.addImage
                            }
                            alt=""
                            style={{
                              width: fitem.width + "px",
                              height: fitem.height + "px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              border: "1px solid black",
                              width: `${Number(fitem.width)}px`,
                              height: `${Number(fitem.height)}px`,
                            }}
                          >
                            Image Field
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {fitem.field_type.label === "Body Content" ? (
                  !!fitem?.cols ? (
                    <>
                      {fitem.show_label && (
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: previewPageProps.module_name === 'TESTING_MANAGEMENT' && (!previewPageProps.font_size_version || previewPageProps.font_size_version === null) ? '12px' : '1.1em',
                            marginBottom: "10px",
                          }}
                        >
                          {fitem.field_label}
                        </div>
                      )}

                      <table
                        className="table is-striped is-hoverable is-fullwidth inner-table"
                        style={{
                          textAlign: fitem.alignment.value.toLowerCase(),
                          width: "100%",
                          tableLayout: "fixed",
                        }}
                      >
                        <tbody style={{ width: "100%" }}>
                          <tr style={{ fontSize: previewPageProps.module_name === 'TESTING_MANAGEMENT' && (!previewPageProps.font_size_version || previewPageProps.font_size_version === null) ? '12px' : '10px'}}>
                            <td
                              style={{
                                width: "10%",
                                textAlign: "left",
                                fontWeight: "1000",
                              }}
                            >
                              S.NO
                            </td>
                            {Array.from({
                              length: Math.min(fitem.cols, 12),
                            }).map((_, index) => {
                              const field =
                                fitem.body_fields &&
                                fitem.body_fields.find(
                                  (field) =>
                                    field.col === index + 1 &&
                                    field.status_id === "ACTIVE" &&
                                    !field.show_as_SubHeading
                                );

                              if (!field) return null;

                              // Only essential change: Parse column_widths if string
                              const columnWidths =
                                typeof fitem.column_widths === "string"
                                  ? JSON.parse(fitem.column_widths)
                                  : fitem.column_widths;

                              return (
                                <td
                                  key={index}
                                  style={{
                                    width:
                                      columnWidths && columnWidths[index]
                                        ? `${
                                            (columnWidths[index] /
                                              fitem.container_width) *
                                            100
                                          }%`
                                        : "100%",
                                    textAlign:
                                      field.alignment.value.toLowerCase(),
                                    fontWeight: "1000",
                                  }}
                                >
                                  {field.show_label ? field.field_label : field.field_type.label}
                                </td>
                              );
                            })}
                          </tr>
                          {_coaRecipe?.map((item, rowIndex) => (
                            <>
                              {fitem.body_fields?.map(
                                (body_field, colIndex) => {
                                  
                                  
                                  if (body_field.field_type.value === "Grouping_Name" && body_field.show_as_SubHeading) {
                                    const groupingNameValue = item[body_field.field_type.value];
                                    if (!uniqueGroupingNames.has(groupingNameValue)) {
                                      uniqueGroupingNames.add(groupingNameValue);
                                      return (
                                        <tr key={`${rowIndex}-${colIndex}`}>
                                          <td
                                            colSpan={fitem.cols + 1}
                                            style={{
                                              textAlign:
                                                body_field.alignment.value.toLowerCase(),
                                            }}
                                          >
                                            {/* <span
                                              style={{
                                                width: "130px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                padding: "10px 0px",
                                              }}
                                            >
                                              Group Name:
                                            </span> */}
                                            <b style={{ textAlign: body_field.alignment.value.toLowerCase(), width: '100%' }}>
                                              {groupingNameValue}
                                            </b>
                                          </td>
                                        </tr>
                                      );
                                    } else {
                                      return null;
                                    }
                                  }
                                  return null;
                                }
                              )}

                              <tr key={rowIndex}>
                                <td style={{ textAlign: "left", width: "10%" }}>
                                  {item.s_no}
                                </td>

                                {Array.from({
                                  length: Math.min(fitem.cols, 12),
                                }).map((_, colIndex) => {
                                  const body_field =
                                    fitem.body_fields &&
                                    fitem.body_fields.find(
                                      (field) =>
                                        field.col === colIndex + 1 &&
                                        field.status_id === "ACTIVE" &&
                                        !field?.show_as_SubHeading
                                    );
                                  if (!body_field) return null;

                                  // let cellContent =
                                  //   item[body_field.field_type.value] || "";
                                  let cellContent = "";
                                  if(body_field.field_type.value === "Pass_Fail" || body_field.field_type.value === "pass_fail"){
                                    cellContent = item['Pass_Fail'] || item['pass_fail'] || '';
                                  }else if(body_field.field_type.value.toLowerCase() === "test_name" || body_field.field_type.value === 'Test_Name'){
                                      cellContent = item["test_name"] || item['Test_Name'];  
                                  }else{
                                    cellContent = item[body_field.field_type.value] || '';
                                  }
                                  // if (
                                  //   body_field.field_type.value ===
                                  //     "results_uom" &&
                                  //   (typeof item.s_no === "string" ||
                                  //     (typeof item.s_no === "number" &&
                                  //       item.test_code !== undefined))
                                  // ) {
                                  //   cellContent =
                                  //     item["result"]
                                  //       ?.map((line) =>
                                  //         typeof line === "string"
                                  //           ? line.trim()
                                  //           : String(line)
                                  //       )
                                  //       ?.join("\n") || "-";
                                  // }

                                  // if (
                                  //   body_field.field_type.value ===
                                  //     "results_without_uom" &&
                                  //   (typeof item.s_no === "string" ||
                                  //     (typeof item.s_no === "number" &&
                                  //       item.test_code !== undefined))
                                  // ) {
                                  //   const results_without_uom = item[
                                  //     "result"
                                  //   ]?.map((item) =>
                                  //     item.replace(/([0-9.]+)\s*\S*$/, "$1")
                                  //   );
                                  //   cellContent =
                                  //     results_without_uom &&
                                  //     !!results_without_uom.length
                                  //       ? results_without_uom
                                  //           ?.map((line) =>
                                  //             typeof line === "string"
                                  //               ? line.trim()
                                  //               : String(line)
                                  //           )
                                  //           ?.join("\n")
                                  //       : "-";
                                  // }
                                  if (
                                    (body_field.field_type.value === "lod_1" || body_field.field_type.value === "Lod_1") &&
                                    (typeof item.s_no === "string" ||
                                      (typeof item.s_no === "number" &&
                                        (item.test_code !== undefined || item.Test_Code !== undefined)))
                                  ) {
                                    if (item.subtest_required2) {
                                      cellContent = null;
                                    } else {
                                      cellContent =
                                        item?.coa_limit?.l1coatext_limits ||
                                        "--";
                                    }
                                  }
                                  if (
                                    body_field.field_type.value === "Loq_2" &&
                                    (typeof item.s_no === "string" ||
                                      (typeof item.s_no === "number" &&
                                        (item.test_code !== undefined || item.Test_Code !== undefined)))
                                  ) {
                                    if (item.subtest_required2) {
                                      cellContent = null;
                                    } else {
                                      cellContent =
                                        item?.coa_limit?.l2coatext_limits ||
                                        "--";
                                    }
                                  }
                                  if ((body_field.field_type.label === "specification_description" || body_field.field_type.value === "specification_description") && (typeof (item.s_no) === "string" || (typeof (item.s_no) === "number" && item.test_code !== undefined))) {
                                    if (previewPageProps.specification_type === "Without Limit") {
                                      if (item.subtest_required2) {
                                        cellContent = null;
                                      } else {
                                        cellContent = '--';
                                      }
                                    }
                                  }

                                  if ((body_field.field_type.label === "Pass/Fail" || body_field.field_type.value === "Pass_Fail") && (typeof (item.s_no) === "string" || (typeof (item.s_no) === "number" && item.test_code !== undefined))) {
                                    if (previewPageProps.specification_type === "Without Limit") {
                                      if (item.subtest_required2) {
                                        cellContent = null;
                                      } else {
                                        cellContent = '--';
                                      }
                                    }
                                  }
                                  if (body_field.field_type.value === 'Uom') {
                                    const normalizedResults = item?.result?.flatMap(line => {
                                      const str = String(line).trim();
                                      return str.replace(/\s+(Min|Max|Mean|SD|RSD)\s*:/gi, '\n$1 :').split('\n').filter(Boolean);
                                    }) || [];

                                    let uomArr = normalizedResults.map(line => {

                                      if (line.includes('UOM')) {
                                        const match = line.match(/UOM(.+)$/);
                                        return match ? match[1].trim() : '';
                                      }
                                      else {
                                        const match = line.match(/(?:\d+(?:\.\d+)?)\s*([a-zA-Z/%]+)\s*$/);
                                        return match ? match[1] : '';
                                      }

                                    });

                                    const hasAnyUom = uomArr.some(u => String(u).trim() !== '');

                                    const resultUomDivs = normalizedResults.map((line, idx) => {
                                      const resultVal = String(line).replace(/([0-9.]+)\s*\S*$/, '$1').trim();
                                      const uom = uomArr[idx] || '';

                                      return (
                                        <div key={idx} style={{ position: 'relative' }}>
                                          <span style={{ visibility: 'hidden' }}>{resultVal}</span>
                                          <span style={{ position: 'absolute', top: '50%', left: '0', transform: 'translateY(-50%)' }}>{uom}</span>
                                        </div>
                                      );
                                    });

                                    if (item.test_type === 'QUAL' && (item.subtest_required === undefined || item.subtest_required === false)) {
                                      cellContent = 'NA';
                                    }
                                    else if (item.test_type === 'QUAL' && item.subtest_required === undefined) {
                                      cellContent = 'NA';
                                    }
                                    else if ((item.test_type === 'QUAL' || item.test_type === 'QUAN') && item.subtest_required === true && typeof item.s_no === 'number') {
                                      cellContent = '';
                                    }
                                    else if (typeof item.s_no === 'number') {
                                      cellContent = hasAnyUom ? resultUomDivs : '';
                                    } else {
                                      cellContent = hasAnyUom ? resultUomDivs : 'NA';
                                    }
                                  }
                                  if (body_field.field_type.value === 'instrument_id') {
                                    const insIds = item.insUsageIds;
                                    const isinhouse = item.subtest_required && item.datasheet_for_subtest === false && rowIndex > 1 && item.is_out_sourced === false;
                                    const isout = item.subtest_required && item.is_out_sourced && item.datasheet_for_subtest
                                    const isSubRow = typeof item.s_no === 'number' && item.subtest_required === true;

                                    cellContent = (
                                      <div style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', height: '100%' }}>
                                        {Array.isArray(insIds) && insIds.length > 0
                                          ? insIds.filter(Boolean).join(', ')
                                          : isSubRow ? '' : (isinhouse || isout) ? '' : 'NA'}</div>);
                                  }
                                  if (body_field.field_type.value === 'instrument_name') {
                                    const names = item.instrumentNames;
                                    const isSubRow = typeof item.s_no === 'number' && item.subtest_required === true;
                                    const isinhouse = item.subtest_required && item.datasheet_for_subtest === false && rowIndex > 1 && item.is_out_sourced === false;
                                    const isout = item.subtest_required && item.is_out_sourced && item.datasheet_for_subtest

                                    cellContent = (
                                      <div style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', height: '100%' }}>
                                        {Array.isArray(names) && names.length > 0
                                          ? names.filter(Boolean).join(', ')
                                          : isSubRow ? '' : (isinhouse || isout) ? '' : 'NA'}
                                      </div>);
                                  }

                                  const columnWidths =
                                    typeof fitem.column_widths === "string"
                                      ? JSON.parse(fitem.column_widths)
                                      : fitem.column_widths;

                                  return (
                                    <td
                                      key={colIndex}
                                      style={{
                                        width:
                                          columnWidths && columnWidths[colIndex]
                                            ? `${
                                                (columnWidths[colIndex] /
                                                  fitem.container_width) *
                                                100
                                              }%`
                                            : "100%",
                                        textAlign:
                                          body_field.alignment.value.toLowerCase(),
                                      }}
                                    >
                                      {(body_field.field_type.label ===
                                        "Standard_Description" ||
                                        body_field.field_type.value ===
                                          "specification_description") &&
                                      cellContent ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: cellContent.replace(
                                              /\n/g,
                                              "<br />"
                                            ),
                                          }}
                                        ></div>
                                      ) : body_field.field_type.value ===
                                        "results_uom"  || body_field.field_type.value === "Results_uom" ? (
                                        <>
                                          {
                                            (!item?.is_na_new_test) && item.result ? <>
                                            {item["result"]?.map((line, index) => (
                                              <>
                                                <div key={index}>
                                                  {typeof line === "string"
                                                    ? (previewPageProps?.module_name === "TESTING_MANAGEMENT"
                                                      ? (/\b\d+(\.\d+)?\b/.test(line)
                                                        ? line.replace(/\bUOM\b\s*/i, '').trim()
                                                        : line.replace(/\bUOM\b.*$/i, '').trim()
                                                      )
                                                      : line.trim()
                                                    )
                                                    : (previewPageProps?.module_name === "TESTING_MANAGEMENT"
                                                      ? (/\b\d+(\.\d+)?\b/.test(String(line))
                                                        ? String(line).replace(/\bUOM\b\s*/i, '').trim()
                                                        : String(line).replace(/\bUOM\b.*$/i, '').trim()
                                                      )
                                                      : String(line)
                                                    )
                                                  }
                                                </div>
                                                </>
                                              )
                                            )}
                                            {Array.isArray(item.sub_cal_details) && item.sub_cal_details.some(sc => sc?.display_in_coa) && (
                                              <div style={{ marginBottom: '8px' }}>
                                                {item.sub_cal_details
                                                  .filter(sc => sc?.display_in_coa)
                                                  .map((subCal, subIndex) => (
                                                      <div key={subIndex}>
                                                        {subCal.name} : {(subCal.value === 'NaN') ? 'Undefined' : subCal.value} {subCal.value === 'NaN' ? '' : subCal.uom_symbol || ''}
                                                        {subCal?.display_slope_in_coa && (<><br /><span>Slope : {subCal?.slope}</span></>)}
                                                        {subCal?.display_intercept_in_coa && (<><br /><span>Intercept : {subCal?.intercept}</span></>)}
                                                      </div>
                                                    ))}
                                              </div>
                                              )}
                                                  {Array.isArray(item?.test_iterations_value_details) &&
                                                    item?.test_iterations_value_details.length > 0 && (
                                                      <div style={{ marginBottom: "8px" }}>
                                                        {item?.test_iterations_value_details.map((iter, iterIndex) => (
                                                          <div key={iterIndex}>
                                                            {iter.iteration_name} : {iter.value}
                                                          </div>
                                                        ))}
                                                      </div>
                                                    )}
                                              </>
                                            : <>{item.result && item['result']?.map((line,index) => {
                                              if(typeof line === 'string'){ 
                                                const lowerInput = line.trim().toLowerCase();
                                                const patterns = [/not\s*applicable/gi, /\bn\/a\b/gi, /\bna\b/gi];
                                                let containsInvalid = patterns.some(pattern => pattern.test(lowerInput));
                                                if (containsInvalid && (item?.sub_test_type === 'QUAN' || item?.test_type ==='QUAN')) {
                                                          let cleaned = line.trim();
                                                          patterns.forEach(pattern => {
                                                              cleaned = cleaned.replace(pattern, '');
                                                          });
                                                          cleaned = cleaned.replace(/\s{2,}/g, ' ')
                                                                          .replace(/\s*,/g, ',')
                                                                          .replace(/,\s*/g, ',')
                                                                          .trim();

                                                          return <div key={index}>{cleaned}</div>;
                                                      }else {
                                                          return <div key={index}>{line}</div>;
                                                      }

                                                  }else{
                                                  const lowerInput = String(line).trim().toLowerCase();
                                                  const patterns = [/not\s*applicable/gi, /\bn\/a\b/gi, /\bna\b/gi];
                                                  let containsInvalid = patterns.some(pattern => pattern.test(lowerInput));
                                                  if (containsInvalid && (item?.sub_test_type === 'QUAN' || item?.test_type ==='QUAN')) {
                                                          let cleaned = String(line).trim();
                                                          patterns.forEach(pattern => {
                                                              cleaned = cleaned.replace(pattern, '');
                                                          });
                                                          cleaned = cleaned.replace(/\s{2,}/g, ' ')
                                                                          .replace(/\s*,/g, ',')
                                                                          .replace(/,\s*/g, ',')
                                                                          .trim();

                                                          return <div key={index}>{cleaned}</div>;
                                                      } else {
                                                          return <div key={index}>{line}</div>;
                                                      }
                                              }})}
                                              {Array.isArray(item.sub_cal_details) && item.sub_cal_details.some(sc => sc?.display_in_coa) && (
                                                  <div style={{ marginBottom: '8px' }}>
                                                  {item.sub_cal_details
                                                    .filter(sc => sc?.display_in_coa)
                                                    .map((subCal, subIndex) => (
                                                      <div key={subIndex}>
                                                        {subCal.name} : {(subCal.value === 'NaN') ? 'Undefined' : subCal.value} {subCal.value === 'NaN' ? '' : subCal.uom_symbol || ''}
                                                        {subCal?.display_slope_in_coa && (<><br /><span>Slope : {subCal?.slope}</span></>)}
                                                        {subCal?.display_intercept_in_coa && (<><br /><span>Intercept : {subCal?.intercept}</span></>)}
                                                      </div>
                                                      ))}
                                                </div>
                                              )}
                                                    {Array.isArray(item?.test_iterations_value_details) &&
                                                      item?.test_iterations_value_details.length > 0 && (
                                                        <div style={{ marginBottom: "8px" }}>
                                                          {item?.test_iterations_value_details.map((iter, iterIndex) => (
                                                            <div key={iterIndex}>
                                                              {iter.iteration_name} : {iter.value}
                                                            </div>
                                                          ))}
                                                        </div>
                                                      )}
                                              </>
                                            }
                                          </>) 
                                        :
                                        body_field.field_type.value ===
                                        "results_without_uom"  || body_field.field_type.value === 'Results' ? (
                                        <> 
                                          {/* First map method is used to remove the uom symbols in results */}
                                          {(item.result && (!item?.is_na_new_test)) 
                                            ?
                                                  item?.test_type === "QUAL"
                                                    ? (
                                                      item["result"]?.map((line, index) => (
                                                        <div key={index}>
                                                          {typeof line === "string" ? line : String(line)}
                                                        </div>
                                                      ))
                                                    ) :
                                              (item["result"].find(
                                                (data) => typeof data === "string")
                                                  ? item["result"]?.map((item) =>
                                                    String(item).replace(
                                                      /([0-9.]+)\s*\S*$/,
                                                      "$1"
                                                    ).replace(previewPageProps?.module_name === "TESTING_MANAGEMENT" ? /UOM.+$/i: /^$/,"")
                                                  )
                                                  .map((line, index) => (
                                                    <div key={index}>
                                                      {typeof line === "string"
                                                        ? line.trim()
                                                        : String(line)}
                                                    </div>
                                                  ))
                                                  : item["result"]?.map((line) => String(line))?.join("\n") || "-") 
                                            : item.result && (
                                              (item["result"]?.map((line, index) => {
                                                  if(typeof line === 'string'){ 
                                                  const with_uom_line = line.replace(/([0-9.]+)\s*[a-zA-Z]+(?=\))/, "$1");
                                                  const lowerInput = with_uom_line.trim().toLowerCase();
                                                  const patterns = [/not\s*applicable/gi, /\bn\/a\b/gi, /\bna\b/gi];
                                                  let containsInvalid = patterns.some(pattern => pattern.test(lowerInput));
                                                  if (containsInvalid && (item?.sub_test_type === 'QUAN' || item?.test_type ==='QUAN')) {
                                                          let cleaned = with_uom_line.trim();
                                                          patterns.forEach(pattern => {
                                                              cleaned = cleaned.replace(pattern, '');
                                                          });
                                                          cleaned = cleaned.replace(/\s{2,}/g, ' ')
                                                                          .replace(/\s*,/g, ',')
                                                                          .replace(/,\s*/g, ',')
                                                                          .trim();

                                                          return <div key={index}>{cleaned}</div>;
                                                      }else {
                                                          return <div key={index}>{with_uom_line}</div>;
                                                      }

                                                  }else{
                                                  const lowerInput = String(line).trim().toLowerCase();
                                                  const patterns = [/not\s*applicable/gi, /\bn\/a\b/gi, /\bna\b/gi];
                                                  let containsInvalid = patterns.some(pattern => pattern.test(lowerInput));
                                                  if (containsInvalid && (item?.sub_test_type === 'QUAN' || item?.test_type ==='QUAN')) {
                                                          let cleaned = String(line).trim();
                                                          patterns.forEach(pattern => {
                                                              cleaned = cleaned.replace(pattern, '');
                                                          });
                                                          cleaned = cleaned.replace(/\s{2,}/g, ' ')
                                                                          .replace(/\s*,/g, ',')
                                                                          .replace(/,\s*/g, ',')
                                                                          .trim();

                                                          return <div key={index}>{cleaned}</div>;
                                                      } else {
                                                          return <div key={index}>{line}</div>;
                                                      }
                                              }
                                            })))
                                          }
                                          {Array.isArray(item.sub_cal_details) && item.sub_cal_details.some(sc => sc?.display_in_coa) && (
                                            <div style={{ marginBottom: '8px' }}>
                                            {item.sub_cal_details
                                              .filter(sc => sc?.display_in_coa)
                                              .map((subCal, subIndex) => (
                                                <div key={subIndex}>
                                                  {subCal.name} : {(subCal.value === 'NaN') ? 'Undefined' : subCal.value}
                                                  {subCal?.display_slope_in_coa && (<><br /><span>Slope : {subCal?.slope}</span></>)}
                                                  {subCal?.display_intercept_in_coa && (<><br /><span>Intercept : {subCal?.intercept}</span></>)}
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                                {Array.isArray(item?.test_iterations_value_details) &&
                                                  item?.test_iterations_value_details.length > 0 && (
                                                    <div style={{ marginBottom: "8px" }}>
                                                      {item?.test_iterations_value_details.map((iter, iterIndex) => (
                                                        <div key={iterIndex}>
                                                          {iter.iteration_name} : {iter.value}
                                                        </div>
                                                      ))}
                                                    </div>
                                                  )}
                                          </>
                                      ) : (
                                        <div style={{ whiteSpace: 'pre-line' }}>{cellContent}</div>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                      <div>
                        {/* <hr /> */}
                        {
                          previewPageProps?.standards_type ? (
                            (isConclusionRemarks === null || isConclusionRemarks === undefined) && !hasConclusionRemark && (
                              <div>
                                <ConclusionTest previewPageProps={previewPageProps} />
                              </div>
                            )
                          ) : (
                            <ConclusionTest previewPageProps={previewPageProps} />
                          )
                        }
                        {<Remarks remarks={previewPageProps.remarks} />}
                      </div>
                    </>
                  ) : (
                    <>
                      {fitem.show_label && (
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: previewPageProps.module_name === 'TESTING_MANAGEMENT' && (!previewPageProps.font_size_version || previewPageProps.font_size_version === null) ? '12px' : '1.1em',
                            marginBottom: "10px",
                          }}
                        >
                          {fitem.field_label}
                        </div>
                      )}
                      <table
                        className="table is-striped is-hoverable is-fullwidth inner-table"
                        style={{
                          textAlign: fitem.alignment.value.toLowerCase(),
                          width: "100%",
                          tableLayout: "fixed",
                        }}
                      >
                        {/* <thead>
                        <tr>
                          <th
                            className="coawidth"
                            style={{ width: "10%" }}
                            scope="col"
                          >
                            S.No.
                          </th>
                          <th scope="col">Test Name</th>
                          {specification_type === "With Limit" && (
                            <th scope="col">Specification</th>
                          )}
                          <th scope="col">Result</th>
                        </tr>
                      </thead> */}
                        <tbody style={{ width: "100%" }}>
                          <tr style={{ fontSize: previewPageProps.module_name === 'TESTING_MANAGEMENT' && (!previewPageProps.font_size_version || previewPageProps.font_size_version === null) ? '12px' : '1.1em' }}>
                            <td
                              style={{
                                textAlign: "left",
                                fontWeight: "1000",
                                width: "10%",
                              }}
                            >
                              S.No.{" "}
                            </td>
                            <td
                              style={{ textAlign: "left", fontWeight: "1000" }}
                            >
                              Test Name
                            </td>
                            {specification_type === "With Limit" && (
                              <td
                                style={{
                                  textAlign: "left",
                                  fontWeight: "1000",
                                }}
                              >
                                Specification
                              </td>
                            )}
                            <td
                              style={{ textAlign: "left", fontWeight: "1000" }}
                            >
                              Result
                            </td>
                          </tr>
                          {_coaRecipe.map((item, index) => {
                            item.desc =
                              item.desc && item.desc.indexOf("\n") > -1
                                ? item.desc.replaceAll("\n", "<br />")
                                : item.desc;
                            return (
                              <tr key={index}>
                                <td style={{ textAlign: "left" }}>
                                  {item.s_no}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <div>{item.name}</div>
                                </td>
                                {specification_type === "With Limit" && (
                                  <td style={{ textAlign: "left" }}>
                                    {item.desc ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: item.desc,
                                        }}
                                      ></div>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                )}
                                <td style={{ textAlign: "left" }}>
                                  {!item?.is_na_new_test ?
                                <>
                                {Array.isArray(item.sub_cal_details) && item.sub_cal_details.some(sc => sc?.display_in_coa) && (
                                    <div style={{ marginBottom: '8px' }}>
                                        {item.sub_cal_details
                                            .filter(sc => sc?.display_in_coa)
                                            .map((subCal, subIndex) => (
                                                <div key={subIndex}>
                                                    {subCal.name} : {(subCal.value === 'NaN') ? 'Undefined' : subCal.value} {subCal.value === 'NaN' ? '' : subCal.uom_symbol || ''}
                                                    {subCal?.display_slope_in_coa && (<><br /><span>Slope : {subCal?.slope}</span></>)}
                                                    {subCal?.display_intercept_in_coa && (<><br /><span>Intercept : {subCal?.intercept}</span></>)}
                                                </div>
                                            ))}
                                    </div>
                                )} 
                                {item.result && item.result.map((r, rIndex) => (
                                    <div key={rIndex} >{r}</div>
                                ))}
                                </>:
                                <>
                                {Array.isArray(item.sub_cal_details) && item.sub_cal_details.some(sc => sc?.display_in_coa) && (
                                    <div style={{ marginBottom: '8px' }}>
                                        {item.sub_cal_details
                                            .filter(sc => sc?.display_in_coa)
                                            .map((subCal, subIndex) => {
                                                const rawValue = (subCal.value || "").toString().trim();
                                                const displayValue = rawValue.toLowerCase() === "nan" ? "Undefined" : rawValue;

                                                const uom = (subCal.uom_symbol || "").toString().trim().toLowerCase();
                                                const invalidSymbols = ["n/a", "na", "notapplicable", "not applicable"];
                                                const showSymbol = !invalidSymbols.includes(uom);

                                                return (
                                                    <div key={subIndex}>
                                                        {subCal.name} : {displayValue} {displayValue === "Undefined" || !showSymbol ? "" : subCal.uom_symbol}
                                                        {subCal?.display_slope_in_coa && (<><br /><span>Slope : {subCal?.slope}</span></>)}
                                                        {subCal?.display_intercept_in_coa && (<><br /><span>Intercept : {subCal?.intercept}</span></>)}
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}
                                
                                {item.result && item.result
                                    .map((r, rIndex) => {
                                        const lowerInput = String(r).toLowerCase();
                                        // Define patterns to remove (case-insensitive)
                                        const patterns = [/not\s*applicable/gi, /\bn\/a\b/gi, /\bna\b/gi];
                                        let containsInvalid = patterns.some(pattern => pattern.test(lowerInput));
                                        if (containsInvalid && (item?.sub_test_type === 'QUAN' || item?.test_type ==='QUAN')) {
                                                let cleaned = r;

                                                // Remove all matching patterns
                                                patterns.forEach(pattern => {
                                                    cleaned = cleaned.replace(pattern, '');
                                                });

                                                // Clean up extra spaces and misplaced commas
                                                cleaned = cleaned.replace(/\s{2,}/g, ' ')     // remove extra spaces
                                                                .replace(/\s*,/g, ',')       // fix space before comma
                                                                .replace(/,\s*/g, ',')       // remove space after commas
                                                                .trim();

                                                return <div key={rIndex}>{cleaned}</div>;
                                            } else {
                                                return <div key={rIndex}>{r}</div>;
                                            }
                                    })}</>}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div>
                        {/* <hr /> */}
                        {
                          previewPageProps?.standards_type ? (
                            (isConclusionRemarks === null || isConclusionRemarks === undefined) && !hasConclusionRemark && (
                              <div>
                                <ConclusionTest previewPageProps={previewPageProps} />
                              </div>
                            )
                          ) : (
                            <ConclusionTest previewPageProps={previewPageProps} />
                          )
                        }
                        {<Remarks remarks={previewPageProps.remarks} />}
                      </div>
                    </>
                  )
                ) : (
                  <></>
                )}
                {isConclusionRemarks === true && fitem?.field_type?.label === "Conclusion/Remarks" &&
                  <RenderConclusionRemark previewPageProps={previewPageProps} fitem={fitem} />
                }

                {fitem.field_type.label === "Bar Code" && (
                  <div className="p-1 columns" style={{ alignItems: "center" }}>
                    <div className="column">
                      <div>
                        <div className="Barcode-container">
                          <Barcode
                            value={
                              (fitem.object_field.field_name &&
                                stripHtml(template_data_fields_values[
                                  fitem.object_field.field_name
                                ])) ||
                              "---"
                            }
                            format="CODE128"
                            displayValue={
                              fitem.show_label === true ? true : false
                            }
                            width={3}
                          />
                          <style>
                            {`
                                 .Barcode-container svg {
                                  width: 100% !important;   
                                  height:50px;
                                 }   
                              `}
                          </style>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {fitem.field_type.label === "QR Code" && (
                  <div className="p-1 columns" style={{ alignItems: "center" }}>
                    <div className="column">
                      <div className="QRcode-container">
                        <div
                          style={{
                            textAlign: fitem.alignment.value.toLowerCase(),
                          }}
                        >
                          <QRCodeSVG
                            // value={fitem.object_field
                            //   .map(
                            //     (item) =>
                            //       `${item.label}: ${
                            //         template_data_fields_values[item.field_name]
                            //       }`
                            //   )
                            //   .join(", ")}
                            value={fitem.object_field.map(item => {
                              const value = stripHtml(
                                template_data_fields_values?.[item.field_name]
                              );
                              return `${item.label}: ${value}`;
                            })
                              .join(",")}
                            size={fitem.width * 1}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
    </>
  );
};

export const GetTR = ({ item, recipe, previewPageProps, getNodes }) => {
  if (item.container_width && item.column_widths) {
    let { column_widths, container_width } = item;
    if (typeof column_widths === "string" && container_width) {
      try {
        item.column_widths = JSON.parse(column_widths);
      } catch (e) {
        console.error("Failed to parse column_widths:", e);
        column_widths = [];
      }
    }
    if (!Array.isArray(column_widths)) {
      column_widths = [];
    }
    item.container_width = parseInt(container_width, 10);
  }

  return (
    <table
      className={`${
        item.isrepeat === "true" ? "repeat-table" : "notRepeat-table"
      }`}
      key={item.seq}
      style={{ width: "100%", tableLayout: "fixed" }}
      cellPadding={0}
      cellSpacing={0}
      border={0}
    >
      <tbody>
        <tr>
          <td
            // className="pr-3"
            style={{
              maxWidth:
                item.column_widths && item.column_widths[0]
                  ? `${(item.column_widths[0] * 100) / item.container_width}%`
                  : "auto",
              verticalAlign:
                recipe.fields.find(
                  (f) =>
                    f.section_seq === item.seq &&
                    f.col === 1 &&
                    f.field_type.label === "Image"
                )?.vertical_alignment?.value ?? "top",
            }}
          >
            <RenderFields
              fields={recipe.fields}
              column_widths={item.column_widths}
              section_seq={item.seq}
              col={1}
              previewPageProps={previewPageProps}
              getNodes={getNodes}
            />
          </td>
          {item.cols > 1 && (
            <td
              // className="pr-3"
              style={{
                maxWidth:
                  item.column_widths && item.column_widths[1]
                    ? `${(item.column_widths[1] * 100) / item.container_width}%`
                    : "",
                width:
                  item.column_widths && item.column_widths[1]
                    ? `${(item.column_widths[1] * 100) / item.container_width}%`
                    : "",
                verticalAlign:
                  recipe.fields.find(
                    (f) =>
                      f.section_seq === item.seq &&
                      f.col === 2 &&
                      f.field_type.label === "Image"
                  )?.vertical_alignment?.value ?? "top",
              }}
            >
              <RenderFields
                fields={recipe.fields}
                column_widths={item.column_widths}
                section_seq={item.seq}
                col={2}
                previewPageProps={previewPageProps}
                getNodes={getNodes}
              />
            </td>
          )}
          {item.cols > 2 && (
            <td
              // className="pr-3"
              style={{
                minWidth:
                  item.column_widths && item.column_widths[2]
                    ? `${(item.column_widths[2] * 100) / item.container_width}%`
                    : "",
                width:
                  item.column_widths && item.column_widths[2]
                    ? `${(item.column_widths[2] * 100) / item.container_width}%`
                    : "",
                verticalAlign:
                  recipe.fields.find(
                    (f) =>
                      f.section_seq === item.seq &&
                      f.col === 3 &&
                      f.field_type.label === "Image"
                  )?.vertical_alignment?.value ?? "top",
              }}
            >
              <RenderFields
                fields={recipe.fields}
                column_widths={item.column_widths}
                section_seq={item.seq}
                col={3}
                previewPageProps={previewPageProps}
                getNodes={getNodes}
              />
            </td>
          )}
          {item.cols > 3 && (
            <td
              // className="pr-3"
              style={{
                minWidth:
                  item.column_widths && item.column_widths[3]
                    ? `${(item.column_widths[3] * 100) / item.container_width}%`
                    : "",
                width:
                  item.column_widths && item.column_widths[3]
                    ? `${(item.column_widths[3] * 100) / item.container_width}%`
                    : "",
                verticalAlign:
                  recipe.fields.find(
                    (f) =>
                      f.section_seq === item.seq &&
                      f.col === 4 &&
                      f.field_type.label === "Image"
                  )?.vertical_alignment?.value ?? "top",
              }}
            >
              <RenderFields
                fields={recipe.fields}
                column_widths={item.column_widths}
                section_seq={item.seq}
                col={4}
                previewPageProps={previewPageProps}
                getNodes={getNodes}
              />
            </td>
          )}
          {item.cols > 4 && (
            <td
              // className="pr-3"
              style={{
                minWidth:
                  item.column_widths && item.column_widths[4]
                    ? `${(item.column_widths[4] * 100) / item.container_width}%`
                    : "",
                width:
                  item.column_widths && item.column_widths[4]
                    ? `${(item.column_widths[4] * 100) / item.container_width}%`
                    : "",
                verticalAlign:
                  recipe.fields.find(
                    (f) =>
                      f.section_seq === item.seq &&
                      f.col === 5 &&
                      f.field_type.label === "Image"
                  )?.vertical_alignment?.value ?? "top",
              }}
            >
              <RenderFields
                fields={recipe.fields}
                column_widths={item.column_widths}
                section_seq={item.seq}
                col={5}
                previewPageProps={previewPageProps}
                getNodes={getNodes}
              />
            </td>
          )}
          {item.cols > 5 && (
            <td
              // className="pr-3"
              style={{
                minWidth:
                  item.column_widths && item.column_widths[5]
                    ? `${(item.column_widths[5] * 100) / item.container_width}%`
                    : "",
                width:
                  item.column_widths && item.column_widths[5]
                    ? `${(item.column_widths[5] * 100) / item.container_width}%`
                    : "",
                verticalAlign:
                  recipe.fields.find(
                    (f) =>
                      f.section_seq === item.seq &&
                      f.col === 6 &&
                      f.field_type.label === "Image"
                  )?.vertical_alignment?.value ?? "top",
              }}
            >
              <RenderFields
                fields={recipe.fields}
                column_widths={item.column_widths}
                section_seq={item.seq}
                col={6}
                previewPageProps={previewPageProps}
                getNodes={getNodes}
              />
            </td>
          )}
        </tr>
      </tbody>
    </table>
  );
};

// first page header component
export const FirstPageHeader = ({
  recipe,
  bodyContentSecSeq,
  previewPageProps,
  printType,
  reduxData,
  reportHeaderData,
}) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      localStorage.setItem(
        "firstPageHeaderHeight",
        containerRef.current.offsetHeight
      );
    }
    if (contentRef.current) {
      localStorage.setItem(
        "firstPageHeaderContentHeight",
        contentRef.current.offsetHeight
      );
    }
  }, []);

  return (
    <>
      <table
        style={{ width: printType === "portrait" ? "782px" : "1111px" }}
        ref={containerRef}
      >
        <tbody className="tableRowGroup" ref={contentRef}>
          {(recipe.sections[0].container_width === null ||
            !recipe.sections[0].container_width ||
            recipe.sections[0].container_width === 100 ||
            recipe.sections[0].container_width === 0) &&
            !previewPageProps?.source &&
            previewPageProps?.object_id !==
              "LIMS_EXPERIMENTS_EXPERIMENT_APPROVAL" && (
              <tr>
                <td className="p-4">
                  <div>
                    <ReportHeader
                      reduxData={reduxData}
                      data={reportHeaderData}
                    />
                  </div>
                </td>
              </tr>
            )}
          <tr>
            <td className="px-4 py-0">
              {recipe.sections &&
                recipe.sections.length > 0 &&
                recipe.sections
                  .filter((item) => item.seq < bodyContentSecSeq)
                  .map((item, index) => {
                    return (
                      <GetTR
                        item={item}
                        recipe={recipe}
                        previewPageProps={previewPageProps}
                      />
                    );
                  })}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

// from 2nd page header component
export const RepeatHeader = ({
  recipe,
  bodyContentSecSeq,
  previewPageProps,
  printType,
  reduxData,
  reportHeaderData,
}) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      localStorage.setItem(
        "repeatHeaderHeight",
        containerRef.current.offsetHeight
      );
    }
    if (contentRef.current) {
      localStorage.setItem(
        "repeatHeaderContentHeight",
        contentRef.current.offsetHeight
      );
    }
  }, []);

  return (
    <>
      <table
        style={{ width: printType === "portrait" ? "782px" : "1111px" }}
        ref={containerRef}
      >
        <tbody className="tableRowGroup" ref={contentRef}>
          {recipe.sections[0].container_width === null ||
            !recipe.sections[0].container_width ||
            recipe.sections[0].container_width === 100 ||
            (recipe.sections[0].container_width === 0 && (
              <tr>
                <td className="p-4">
                  {!previewPageProps?.source &&
                    previewPageProps?.object_id !==
                      "LIMS_EXPERIMENTS_EXPERIMENT_APPROVAL" && (
                      <div>
                        <ReportHeader
                          reduxData={reduxData}
                          data={reportHeaderData}
                        />
                      </div>
                    )}
                </td>
              </tr>
            ))}
          <tr>
            <td className="px-4 py-0">
              {recipe.sections &&
                recipe.sections.length > 0 &&
                recipe.sections
                  .filter((item) => item.seq < bodyContentSecSeq)
                  .map((item, index) => {
                    if (item.isrepeat === "true") {
                      return (
                        <GetTR
                          item={item}
                          recipe={recipe}
                          previewPageProps={previewPageProps}
                        />
                      );
                    }
                  })}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

// first page footer component
export const FirstPageFooter = ({
  recipe,
  bodyContentSecSeq,
  previewPageProps,
  printType,
  reduxData,
}) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      localStorage.setItem(
        "firstPageFooterHeight",
        containerRef.current.offsetHeight
      );
    }
    if (contentRef.current) {
      localStorage.setItem(
        "firstPageFooterContentHeight",
        contentRef.current.offsetHeight
      );
    }
  }, []);

  return (
    <>
      <table
        style={{
          width: printType === "portrait" ? "782px" : "1111px",
        }}
        ref={containerRef}
      >
        <tbody className="tableFooterGroup" ref={contentRef}>
          <tr>
            <td>
              {recipe.sections &&
                recipe.sections.length > 0 &&
                recipe.sections
                  .filter((item) => item.seq > bodyContentSecSeq)
                  .map((item, index) => {
                    return (
                      <GetTR
                        item={item}
                        recipe={recipe}
                        previewPageProps={previewPageProps}
                      />
                    );
                  })}
            </td>
          </tr>
          <tr>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {previewPageProps?.object_id !==
                  "LIMS_EXPERIMENTS_EXPERIMENT_APPROVAL" && (
                  <b>
                    Printed By :{" "}
                    {reduxData?.meta?.first_name + " " + reduxData?.meta?.last_name}
                  </b>
                )}
                {previewPageProps?.object_id !==
                  "LIMS_EXPERIMENTS_EXPERIMENT_APPROVAL" && (
                  <b>Printed On : {getlatestNoW(reduxData.current_auth.time_zone_value,reduxData.current_auth.date_format,reduxData.current_auth.time_format_value)}</b>
                )}
                {previewPageProps.showCopyNo && (
                  <p>
                    Copy no.{" "}
                    {previewPageProps.coa_print_count
                      ? previewPageProps.coa_print_count + 1
                      : 1}
                  </p>
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

// Repeat footer component
export const RepeatFooter = ({
  recipe,
  bodyContentSecSeq,
  previewPageProps,
  printType,
  reduxData,
}) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      localStorage.setItem(
        "repeatFooterHeight",
        containerRef.current.offsetHeight
      );
    }
    if (contentRef.current) {
      localStorage.setItem(
        "repeatFooterContentHeight",
        contentRef.current.offsetHeight
      );
    }
  }, []);

  return (
    <>
      <table
        style={{ width: printType === "portrait" ? "782px" : "1111px" }}
        ref={containerRef}
      >
        <tbody className="tableFooterGroup" ref={contentRef}>
          <tr>
            <td>
              {recipe.sections &&
                recipe.sections.length > 0 &&
                recipe.sections
                  .filter((item) => item.seq > bodyContentSecSeq)
                  .map((item, index) => {
                    if (item.isrepeat === "true") {
                      return (
                        <GetTR
                          item={item}
                          recipe={recipe}
                          previewPageProps={previewPageProps}
                        />
                      );
                    }
                  })}
            </td>
          </tr>
          <tr>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {previewPageProps?.object_id !==
                  "LIMS_EXPERIMENTS_EXPERIMENT_APPROVAL" && (
                  <b>
                    Printed By :{" "}
                    {reduxData?.meta?.first_name + " " + reduxData?.meta?.last_name}
                  </b>
                )}
                {previewPageProps?.object_id !==
                  "LIMS_EXPERIMENTS_EXPERIMENT_APPROVAL" && (
                  <b>Printed On : {getlatestNoW(reduxData.current_auth.time_zone_value,reduxData.current_auth.date_format,reduxData.current_auth.time_format_value)}</b>
                )}
                {previewPageProps.showCopyNo && (
                  <p>
                    Copy no.{" "}
                    {previewPageProps.coa_print_count
                      ? previewPageProps.coa_print_count + 1
                      : 1}
                  </p>
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

// Bottom footer component
export const BottomFooter = ({
  recipe,
  bodyContentSecSeq,
  previewPageProps,
  printType,
  reduxData,
}) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      localStorage.setItem(
        "bottomFooterHeight",
        containerRef.current.offsetHeight
      );
    }
    if (contentRef.current) {
      localStorage.setItem(
        "bottomFooterCotentHeight",
        contentRef.current.offsetHeight
      );
    }
  }, []);

  return (
    <>
      <table
        style={{ width: printType === "portrait" ? "782px" : "1111px" }}
        ref={containerRef}
      >
        <tbody className="tableFooterGroup" ref={contentRef}>
          <tr>
            <td>
              {recipe.sections &&
                recipe.sections.length > 0 &&
                recipe.sections
                  .filter((item) => item.seq > bodyContentSecSeq && item.isfooter)
                  .map((item, index) => {
                      return (
                        <GetTR
                          item={item}
                          recipe={recipe}
                          previewPageProps={previewPageProps}
                        />
                      );
                  })}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

// full body component
export const BodyContainer = ({
  recipe,
  bodyContentSecSeq,
  previewPageProps,
  printType,
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      localStorage.setItem(
        "totalBodyHeight",
        containerRef.current.offsetHeight
      );
    }
  }, []);

  return (
    <table style={{ width: printType === "portrait" ? "782px" : "1111px" }}>
      <tbody>
        <tr ref={containerRef}>
          <td className="p-4">
            {recipe.sections &&
              recipe.sections.length > 0 &&
              recipe.sections
                .filter((item) => item.seq === bodyContentSecSeq)
                .map((item, index) => {
                  return (
                    <GetTR
                      item={item}
                      recipe={recipe}
                      previewPageProps={previewPageProps}
                    />
                  );
                })}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export const PrintPreviewPage = ({
  previewPageProps,
  printType,
  updateState,
  reduxData,
  reportHeaderData,coaprintcount
}) => {
  const [firstPageBodyHeight, setFirstPageBodyHeight] = useState(0);
  const [repeatPageBodyHeight, setRepeatPageBodyHeight] = useState(0);
  const [bodyPages, setBodyPages] = useState();

  const nonFootersRef = useRef(null);
  const containerRef = useRef(null);
  const previewRef = useRef(null);

  useEffect(() => {
    setFirstPageBodyHeight(
      Number(
        (printType === "portrait" ? 1145 : 760) -
          (localStorage.getItem("firstPageHeaderHeight") || 0) -
          (localStorage.getItem("repeatFooterHeight") || 0)
      )
    );
    setRepeatPageBodyHeight(
      Number(
        (printType === "portrait" ? 1145 : 760) -
          (localStorage.getItem("repeatHeaderHeight") || 0) -
          (localStorage.getItem("repeatFooterHeight") || 0)
      )
    );
  }, [
    localStorage.getItem("firstPageHeaderHeight"),
    localStorage.getItem("repeatPageHeaderHeight"),
    localStorage.getItem("firstPageFooterHeight"),
    localStorage.getItem("repeatFooterHeight"),
  ]);

  useEffect(() => {
    if (firstPageBodyHeight) {
      BodyPage();
    }
  }, [firstPageBodyHeight]);

  // BodyPage methond is to find the all pages body that is storing in pages
  const BodyPage = () => {
    const nonFooterNodes = nonFootersRef.current.querySelectorAll("tr");
    // const bodyContent = Array.from(containerRef.current.children);
    const firstTd = containerRef.current.querySelector("td");
    const allSubNodes = Array.from(firstTd.children);
    const bodyNodes = [];
    allSubNodes.forEach((eachNode) => {
      if (eachNode.tagName === "TABLE") {
        const tbody = eachNode.querySelector("tbody");
        const allTrs = tbody ? Array.from(tbody.querySelectorAll("tr")) : [];
        allTrs.forEach((eachTR, index) => {
          bodyNodes.push(eachTR);
        });
      } else {
        bodyNodes.push(eachNode);
      }
    });
    const pages = [];
    let currentPage = [];
    let currentHeight = 0;
    // let overflowNode = null;
    const firstTrNode = bodyNodes.find(
      (node) => node instanceof HTMLTableRowElement
    );
    const tdNodes = firstTrNode.querySelectorAll("td");
    firstTrNode.style.width = printType === "portrait" ? "782px" : "1111px";
    tdNodes.forEach((td) => {
      td.style.padding = ".7em .75em";
      td.style.fontSize = "0.97rem";
      td.style.maxWidth = "200px";
      td.style.fontWeight = "1000";
      td.style.textAlign = "left";
      td.style.boxSizing = "inherit";
      td.style.display = "table-cell";
      td.style.overflowWrap = "break-word";
    });
    const firstTrNodeHeight = firstTrNode.offsetHeight;
    firstTrNode.style.setProperty("background-color", "#dee2e7", "important");
    firstTrNode.style.setProperty("color", "#000000", "important");
    let addEmptyPage = false;
    const finalNodes = [...bodyNodes,...nonFooterNodes];
    finalNodes.forEach((orginalNode, index) => {
      let node = orginalNode;
      const isNodeIsTR = node instanceof HTMLTableRowElement;
      if (!!isNodeIsTR) {
        const tdNodes = node.querySelectorAll("td");
        node.style.width = printType === "portrait" ? "782px" : "1111px";
        tdNodes.forEach((node) => {
          node.style.padding = ".7em .75em";
          node.style.fontSize = "0.97rem";
          node.style.maxWidth = "200px";
          // node.style.fontWeight ="1000";
          node.style.textAlign = "left";
          node.style.boxSizing = "inherit";
          node.style.display = "table-cell";
          node.style.overflowWrap = "break-word";
        });
      }
      let nodeHeight = !!isNodeIsTR
                          ? node.offsetHeight
                          : index > 0
                            ? node.offsetHeight + 20
                            : node.offsetHeight + 10;

      if (!!isNodeIsTR && index+1 > bodyNodes.length) {
        const divNode = document.createElement('div');
        divNode.className = 'converted-tr';
        Array.from(node.children).forEach(td => {
          if (td instanceof HTMLTableCellElement) {
            td.style.maxWidth = "100%";
            const divChild = document.createElement('div');
            divChild.innerHTML = td.innerHTML;
            divChild.style.cssText = td.style.cssText;
            divNode.appendChild(divChild);
          }
        });
        divNode.style.display = 'flex';
        divNode.style.justifyContent = 'space-between';
        divNode.style.gap = '10px';
        divNode.style.width = '100%';
        node.parentNode.replaceChild(divNode, node);
        nodeHeight =divNode.offsetHeight;
      }
      const maxHeight =
        !!pages && pages?.length ? repeatPageBodyHeight : firstPageBodyHeight;
      if (currentHeight + nodeHeight > maxHeight) {
        pages.push([...currentPage]);
        currentPage = [];
        currentHeight = 0;
      }
      // to add tests table header for all pages
      if (!!pages.length && currentHeight === 0 && isNodeIsTR && index+1 <= bodyNodes.length) {
        currentPage.push(firstTrNode, node);
        currentHeight = currentHeight + firstTrNodeHeight + nodeHeight;
      } else {
        currentPage.push(node);
        currentHeight += nodeHeight;
        if( index+1 === finalNodes.length){
          //for bottom footer's
          if(Number(localStorage.getItem("bottomFooterCotentHeight")) + currentHeight > maxHeight ){
            addEmptyPage = true;
          }
        }
      }
      // document.body.removeChild(node);
    });
    if (currentPage.length > 0) {
      if(addEmptyPage){
        pages.push(currentPage);
        pages.push([]);
      }else{
        pages.push(currentPage);
      }
    }
    setBodyPages(pages);
  };

  const handlePrint = (orientation) => {
    // Concatenate all CSS styles needed for print
    const css = `${matlIconCss}${styleCss}${mainCss}${printCss}${qmsCss}${testReportCss}`;
    const rootClass = document.getElementById("root").className;
    // const htmlContent = previewRef.current?.innerHTML;
    const htmlContent = document.getElementById("printNodes").innerHTML;

    // Create the print-ready HTML with styling
    const printHtml = `
        <!DOCTYPE html>
        <html>
          <head>
            <style>
              ${css}
              @media print {
                @page { size: ${orientation}; }
              }
            </style>
          </head>
          <body>
            <div id="root" class="${rootClass}">
              ${htmlContent}
            </div>
          </body>
        </html>
      `;

    // Create an iframe to hold the print document
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    // Access the iframe's window and document to load the content
    const winPrint = iframe.contentWindow;
    winPrint.document.open();
    winPrint.document.write(printHtml);
    winPrint.document.close();

    // Focus on the iframe and trigger print
    // winPrint.focus();
    setTimeout(() => {
      winPrint.focus();
      winPrint.print();
      winPrint.close();
      iframe.remove();
    }, 250); // Adjust if necessary for complex content

    updateState(false); // Hide the print options after print is triggered
  };

  let lastNodeAvailable = false;

  return (
    <>
      <div className={`popup ${previewPageProps.module_name === 'TESTING_MANAGEMENT' && !previewPageProps.font_size_version ? 'testing-coa-preview' : ''}`}>
        <div className="modal is-active" style={{display:'flex', paddingTop:'80px', paddingBottom:'30px'}}>
          {/* To find the height of each component  */}
          <div
            className="preview-container"
            style={{
              width: printType === "portrait" ? "794px" : "1123px",
              fontFamily: "Arial",
              visibility: "hidden",
              position: "absolute",
              left: "-9999px",
            }}
          >
            <FirstPageHeader
              recipe={previewPageProps.recipe}
              bodyContentSecSeq={previewPageProps.bodyContentSecSeq}
              previewPageProps={previewPageProps}
              printType={printType}
              reduxData={reduxData}
              reportHeaderData={reportHeaderData}
            />
            <RepeatHeader
              recipe={previewPageProps.recipe}
              bodyContentSecSeq={previewPageProps.bodyContentSecSeq}
              previewPageProps={previewPageProps}
              printType={printType}
              reduxData={reduxData}
              reportHeaderData={reportHeaderData}
            />
            <BodyContainer
              recipe={previewPageProps.recipe}
              bodyContentSecSeq={previewPageProps.bodyContentSecSeq}
              previewPageProps={previewPageProps}
              printType={printType}
            />
            <FirstPageFooter
              recipe={previewPageProps.recipe}
              bodyContentSecSeq={previewPageProps.bodyContentSecSeq}
              previewPageProps={previewPageProps}
              printType={printType}
              reduxData={reduxData}
            />
            <RepeatFooter
              recipe={previewPageProps.recipe}
              bodyContentSecSeq={previewPageProps.bodyContentSecSeq}
              previewPageProps={previewPageProps}
              printType={printType}
              reduxData={reduxData}
            />

            <BottomFooter
              recipe={previewPageProps.recipe}
              bodyContentSecSeq={previewPageProps.bodyContentSecSeq}
              previewPageProps={previewPageProps}
              printType={printType}
              reduxData={reduxData}
            />
          </div>
          {/*To divide total body into nodes*/}
          {!bodyPages && 
          <table
            style={{
              // display: "none",
              width: printType === "portrait" ? "782px" : "1111px",
              fontFamily: "Arial",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td ref={containerRef}>
                  {previewPageProps.recipe.sections &&
                    previewPageProps.recipe.sections.length > 0 &&
                    previewPageProps.recipe.sections
                      .filter(
                        (item) =>
                          item.seq === previewPageProps.bodyContentSecSeq
                      )
                      .map((item, index) => {
                        return (
                          <GetTR
                            item={item}
                            recipe={previewPageProps.recipe}
                            previewPageProps={previewPageProps}
                            getNodes={true}
                          />
                        );
                      })}
                </td>
              </tr>
            </tbody>
          </table>}

          {/* non-repeat and non-bottom footers */}
          { !bodyPages &&
          <table
           style={{
              // display: "none",
              width: printType === "portrait" ? "782px" : "1111px",
              fontFamily: "Arial",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td ref={nonFootersRef}>
                  {previewPageProps.recipe.sections &&
                    previewPageProps.recipe.sections.length > 0 &&
                    previewPageProps.recipe.sections
                      .filter((item) => item.seq > previewPageProps.bodyContentSecSeq)
                      .map((item, index) => {
                        if (item.isrepeat !== "true" && !item?.isfooter) {
                          return (
                            <GetTR
                              item={item}
                              recipe={previewPageProps.recipe}
                              previewPageProps={previewPageProps}
                            />
                          );
                        }
                      })
                  }
                </td>
              </tr>
            </tbody>
          </table>}

          {/* Actual Component starts from here*/}
          <section className="preview-container">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                fontSize: "20px",
                backgroundColor: "#dee2e7",
                height: "65px",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            >
              <b style={{ marginLeft: "10px" }}>Print Preview</b>
              <button style={{ marginRight: "15px" }} className="delete" aria-label="close"
                onClick={(e) => {
                  updateState(false);
                }}>
              </button>
            </div>
            <div className="preview-body" ref={previewRef} id="printNodes">
              {bodyPages?.map((page, index) => {
                const firstDiv = page[0]?.tagName === "DIV" && index === 0 ? page[0] : null;
                let lastDiv = null;
                const updatedPage = firstDiv ? page.slice(1) : page;
                const subPages = [[],[]];
                let fountLastDiv = false;
                let lastDivNodeAvaliableInSamePage = false;
                updatedPage.forEach(item => {
                    if (item.tagName === "DIV") {
                      lastDiv = item;
                      lastNodeAvailable = true;
                      lastDivNodeAvaliableInSamePage = true;
                      fountLastDiv = true;
                      return;
                    }
                    if (!fountLastDiv) {
                      subPages[0].push(item); // before div
                    } else {
                      subPages[1].push(item); // after div
                    }
                  });
                const trNodes = page.filter((node) => node.tagName === "TR");
                return (
                  <>
                    {index === 0 ? (
                      <div
                        // className=""
                        className={`preview-first-page ${previewPageProps.module_name === 'TESTING_MANAGEMENT' && (!previewPageProps.font_size_version || previewPageProps.font_size_version === null) ? 'testing-coa-preview' : ''}`}
                        style={{
                          width: printType === "portrait" ? "794px" : "1123px",
                          // position: "relative",
                          fontFamily: "Arial",
                        }}
                      >
                        {!!Number(
                          localStorage.getItem("firstPageHeaderContentHeight")
                        ) && (
                          <div>
                            <FirstPageHeader
                              recipe={previewPageProps.recipe}
                              bodyContentSecSeq={
                                previewPageProps.bodyContentSecSeq
                              }
                              previewPageProps={previewPageProps}
                              printType={printType}
                              reduxData={reduxData}
                              reportHeaderData={reportHeaderData}
                            />
                          </div>
                        )}
                        <div
                          style={{
                            height: `${
                              (printType === "portrait" ? 1145 : 760) -
                              ((!!Number(localStorage.getItem("firstPageHeaderContentHeight")) 
                                      ? Number(localStorage.getItem("firstPageHeaderHeight" || 0))
                                      : 0) +
                                (!!Number(localStorage.getItem("repeatFooterContentHeight"))
                                      ? Number(localStorage.getItem("repeatFooterHeight" || 0))
                                      : 0) +
                                (index+1 === bodyPages.length && !!Number(localStorage.getItem("bottomFooterCotentHeight"))
                                      ?  Number(localStorage.getItem("bottomFooterHeight" || 0))
                                      : 0
                                ))
                            }px`,
                          }}
                        >
                          {firstDiv && (
                            <div
                              style={{ width: "100%" }}
                              dangerouslySetInnerHTML={{
                                __html: firstDiv.outerHTML,
                              }}
                            />
                          )}
                          <table
                            className="table is-striped is-hoverable is-fullwidth inner-table preview-table"
                            style={{
                              width: "100%",
                              tableLayout: "fixed",
                            }}
                          >
                            <tbody>
                              {subPages[0].map((trNode, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      index === 0 ? "#dee2e7" : "",
                                    color: index === 0 ? "#000000" : "",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: trNode.innerHTML,
                                  }}
                                />
                              ))}
                            </tbody>
                          </table>
                          {lastDiv && lastDiv !== firstDiv && (
                            <div
                              style={{ width: "100%" }}
                              dangerouslySetInnerHTML={{
                                __html: lastDiv.outerHTML,
                              }}
                            />
                          )}
                          {subPages[1]?.length > 0 && (
                              <div
                                className="converted-table-container"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                  gap: "10px",
                                }}
                              >
                                {subPages[1].map((trNode, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="converted-tr"
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                      }}
                                    >
                                      {Array.from(trNode.children).map((tdNode, tdIndex) => (
                                        <div
                                          key={tdIndex}
                                          className="converted-td"
                                          style={{
                                            maxWidth: "100%",
                                            flex:1,
                                          }}
                                          dangerouslySetInnerHTML={{ __html: tdNode.innerHTML }}
                                        />
                                      ))}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                        </div>
                        {!!Number(
                          localStorage.getItem("repeatFooterContentHeight")
                        ) && (
                          <div>
                            {index+1 === bodyPages.length &&
                            <BottomFooter
                              recipe={previewPageProps.recipe}
                              bodyContentSecSeq={
                                previewPageProps.bodyContentSecSeq
                              }
                              previewPageProps={previewPageProps}
                              printType={printType}
                              reduxData={reduxData}
                            />}
                            <RepeatFooter
                              recipe={previewPageProps.recipe}
                              bodyContentSecSeq={
                                previewPageProps.bodyContentSecSeq
                              }
                              previewPageProps={previewPageProps}
                              printType={printType}
                              reduxData={reduxData}
                            />
                            {/* <FirstPageFooter
                              recipe={previewPageProps.recipe}
                              bodyContentSecSeq={
                                previewPageProps.bodyContentSecSeq
                              }
                              previewPageProps={previewPageProps}
                              printType={printType}
                              reduxData={reduxData}
                            /> */}
                          </div>
                        )}
                        <div
                          className="page_no"
                          style={{
                            width: printType === "portrait" ? "100%" : "100%",
                          }}
                        >
                          <p>
                            Page No : {index + 1} of {bodyPages.length}
                          </p>
                        </div>
                      </div>
                    ) :(
                      <div
                        // className=""
                        className={`preview-repeat-page ${previewPageProps.module_name === 'TESTING_MANAGEMENT' && (!previewPageProps.font_size_version || previewPageProps.font_size_version === null) ? 'testing-coa-preview' : ''}`}
                        
                        style={{
                          width: printType === "portrait" ? "794px" : "1123px",
                          fontFamily: "Arial",
                        }}
                      >
                        {!!Number(
                          localStorage.getItem("repeatHeaderContentHeight")
                        ) && (
                          <div>
                            <RepeatHeader
                              recipe={previewPageProps.recipe}
                              bodyContentSecSeq={
                                previewPageProps.bodyContentSecSeq
                              }
                              previewPageProps={previewPageProps}
                              printType={printType}
                              reduxData={reduxData}
                              reportHeaderData={reportHeaderData}
                            />
                          </div>
                        )}
                        <div
                          style={{
                            height: `${
                              (printType === "portrait" ? 1145 : 760) -
                              ((!!Number(localStorage.getItem("repeatHeaderContentHeight"))
                                ? Number(localStorage.getItem("repeatHeaderHeight") || 0)
                                : 0) +
                                (!!Number(localStorage.getItem("repeatFooterContentHeight"))
                                  ? Number(localStorage.getItem("repeatFooterHeight") || 0)
                                  : 0) +
                                (index+1 === bodyPages.length && !!Number(localStorage.getItem("bottomFooterCotentHeight"))
                                    ? Number(localStorage.getItem("bottomFooterHeight") || 0)
                                    : 0))
                            }px`,
                          }}
                        >
                          { !lastNodeAvailable || (lastNodeAvailable && !!subPages[1].length) || (lastNodeAvailable && lastDivNodeAvaliableInSamePage )
                            ? <table
                                className={`table is-fullwidth inner-table ${ !lastNodeAvailable || (lastNodeAvailable && !!subPages[1].length) || (lastNodeAvailable && lastDivNodeAvaliableInSamePage )? "is-striped is-hoverable" : ""}`}
                                style={{ width: "100%", tableLayout: "fixed" }}
                              >
                                <tbody>
                                  {subPages[0].map((trNode, index) => (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor:
                                          index === 0 &&  (!lastNodeAvailable || (lastNodeAvailable && !!subPages[1].length) || (lastNodeAvailable && lastDivNodeAvaliableInSamePage )) ? "#dee2e7" : "",
                                        color: index === 0 && (!lastNodeAvailable || (lastNodeAvailable && !!subPages[1].length) || (lastNodeAvailable && lastDivNodeAvaliableInSamePage )) ? "#000000" : "",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: trNode.innerHTML,
                                      }}
                                    />
                                  ))}
                                </tbody>
                              </table> 
                            : subPages[0]?.length > 0 && (
                              <div
                                className="converted-table-container"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                  gap: "10px",
                                }}
                              >
                                {subPages[0].map((trNode, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="converted-tr"
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                      }}
                                    >
                                      {Array.from(trNode.children).map((tdNode, tdIndex) => (
                                        <div
                                          key={tdIndex}
                                          className="converted-td"
                                          style={{
                                            maxWidth: "100%",
                                            flex:1,
                                          }}
                                          dangerouslySetInnerHTML={{ __html: tdNode.innerHTML }}
                                        />
                                      ))}
                                    </div>
                                  );
                                })}
                              </div>
                              )
                          }
                          {lastDiv && (
                            <div
                              style={{ width: "100%" }}
                              dangerouslySetInnerHTML={{
                                __html: lastDiv.outerHTML,
                              }}
                            />
                          )}
                           {subPages[1]?.length > 0 && (
                              <div
                                className="converted-table-container"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                  gap: "10px",
                                }}
                              >
                                {subPages[1].map((trNode, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="converted-tr"
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                      }}
                                    >
                                      {Array.from(trNode.children).map((tdNode, tdIndex) => (
                                        <div
                                          key={tdIndex}
                                          className="converted-td"
                                          style={{
                                            maxWidth: "100%",
                                            flex:1,
                                          }}
                                          dangerouslySetInnerHTML={{ __html: tdNode.innerHTML }}
                                        />
                                      ))}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                        </div>
                        {!!Number(
                          localStorage.getItem("repeatFooterContentHeight")
                        ) && (
                          <div>
                            {index+1 === bodyPages.length &&
                            <BottomFooter
                              recipe={previewPageProps.recipe}
                              bodyContentSecSeq={
                                previewPageProps.bodyContentSecSeq
                              }
                              previewPageProps={previewPageProps}
                              printType={printType}
                              reduxData={reduxData}
                            />}
                            <RepeatFooter
                              recipe={previewPageProps.recipe}
                              bodyContentSecSeq={
                                previewPageProps.bodyContentSecSeq
                              }
                              previewPageProps={previewPageProps}
                              printType={printType}
                              reduxData={reduxData}
                            />
                          </div>
                        )}
                        <div
                          className="page_no"
                          style={{
                            width: printType === "portrait" ? "100%" : "100%",
                          }}
                        >
                          <p>
                            Page No : {index + 1} of {bodyPages.length}
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
            <div
              style={{
                backgroundColor: "#dee2e7",
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "65px",
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            >
              <button
                className="preview_print_button"
                style={{
                  backgroundColor: "#bec5d0",
                  borderRadius: "5px",
                  color: "rgba(0, 0, 0, 0.55)",
                  fontSize: "17px",
                  border: "5px solid #bec5d0",
                  margin: "3px 10px 3px",
                  width: "90px",
                  cursor: "pointer",
                  height: "40px",
                }}
                onClick={() => {
                  handlePrint(printType);
                  coaprintcount();
                }}
              >
                Print
              </button>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};
